import { useTranslation } from 'react-i18next'
import { Box, MenuItem, TextField } from '@mui/material'
import { StateSchema } from '@/hooks/form/models'

import keys from '@/utils/keys'
import { BEWeekdayEnum, BEDayEnum } from '@/enums'

type Props = {
  state: StateSchema
  handleOnChange: (name: string, value: any) => void
}

const WeekdayPeriodComponent = ({ state, handleOnChange }: Props) => {
  const { t } = useTranslation()

  const weekDayOptions = [
    ...keys(BEWeekdayEnum).map((x) => {
      return {
        index: BEWeekdayEnum[x],
        label: x.toLowerCase(),
      }
    }),
  ]

  const dayOptions = [
    ...keys(BEDayEnum).map((x) => {
      return {
        index: BEDayEnum[x],
        label: x.toLowerCase(),
      }
    }),
  ]

  return (
    <>
      <Box my={2}>
        <TextField
          fullWidth
          name="recurrenceWeekday"
          margin="dense"
          value={state.recurrenceWeekday.value || ''}
          onChange={(e: any) =>
            handleOnChange('recurrenceWeekday', e.target.value)
          }
          label={t('labels.weekday')}
          select
        >
          <MenuItem value="" disabled>
            <Box fontStyle="italic">{t('selectOne')}</Box>
          </MenuItem>
          {(weekDayOptions || []).map((item) => (
            <MenuItem key={item.index} value={item.index}>
              {t(`recurrenceWeekdayType.${item.label}`)}
            </MenuItem>
          ))}
        </TextField>
      </Box>
      <Box my={2} mb={3} maxWidth={400}>
        <TextField
          fullWidth
          name="day"
          value={state.day.value || ''}
          onChange={(e: any) => handleOnChange('day', e.target.value)}
          label={t('labels.day')}
          select
        >
          <MenuItem value="" disabled>
            <Box fontStyle="italic">{t('selectOne')}</Box>
          </MenuItem>
          {(dayOptions || []).map((item) => (
            <MenuItem key={item.index} value={item.index}>
              {t(`dayType.${item.label}`)}
            </MenuItem>
          ))}
        </TextField>
      </Box>
    </>
  )
}

export default WeekdayPeriodComponent
